import type { ComponentType } from 'react';
import type { ConfigRendererProps } from './types';
import { DefaultConfigRenderer } from './DefaultConfigRenderer';
import { EventTriggerConfigRenderer } from './event-trigger/EventTriggerConfigRenderer';
import { ExtractDocumentContentConfigRenderer } from './ExtractDocumentContentConfigRenderer';
import { SchedulePaymentConfigRenderer } from './SchedulePaymentConfigRenderer';
import { FetchPurchaseOrderFromFamousConfigRenderer } from './FetchPurchaseOrderFromFamousConfigRenderer';
import { ClassifyDocumentConfigRenderer } from './ClassifyDocumentConfigRenderer';
import { ProcessPickTicketBOLConfigRenderer } from './ProcessPickTicketBOLConfigRenderer';

export type { ConfigRendererProps, StepNodeData, StepNode } from './types';

/**
 * Registry mapping step types to their config renderer components
 */
const configRendererRegistry: Record<
  string,
  ComponentType<ConfigRendererProps>
> = {
  event_trigger: EventTriggerConfigRenderer,
  extract_document_content: ExtractDocumentContentConfigRenderer,
  schedule_payment: SchedulePaymentConfigRenderer,
  fetch_purchase_order_from_famous: FetchPurchaseOrderFromFamousConfigRenderer,
  classify_document: ClassifyDocumentConfigRenderer,
  process_pick_ticket_bol: ProcessPickTicketBOLConfigRenderer,
};

/**
 * Get the config renderer component for a given step type
 */
export function getConfigRenderer(
  stepType: string,
): ComponentType<ConfigRendererProps> {
  return configRendererRegistry[stepType] ?? DefaultConfigRenderer;
}

/**
 * Register a config renderer for a step type
 */
export function registerConfigRenderer(
  stepType: string,
  renderer: ComponentType<ConfigRendererProps>,
): void {
  configRendererRegistry[stepType] = renderer;
}
